export enum MDIntent
{
    Default = 'defaultIntent',
    Success = 'successIntent',
    Warning = 'warningIntent',
    Danger = 'dangerIntent'
}
